<template>
  <div class="filter-item-wrapper">
    <label
      :for="'input_' + identifier"
      class="label"
      :title="title || label"
    >
      <span v-html="label" />
      <InfoIcon
        v-if="hasInfoIcon"
        popup-ref="showBrandsPopup"
      />
    </label>
    <DropDown
      :data-items="items"
      :filterable="true"
      @change="filterChangeHandler"
      :value="dropdownValues"
      :id="'input_' + identifier"
      :text-field="'label'"
      :data-item-key="'value'"
      :disabled="disabled"
      :popup-class-name="popupClassName"
    />
  </div>
</template>

<script>
import DropDown from '~/components/input-components/DropDown'
import InfoIcon from '~/components/InfoIcon.vue'

export default {
  name: 'AttributeFilterDropDown',
  components: {
    DropDown,
    InfoIcon
  },
  props: {
    filterValues: {
      type: Array || null,
      required: true,
      default() {
        return []
      }
    },
    popupClassName: {
      type: String,
      default() {
        return ''
      }
    },
    label: {
      type: String,
      required: true,
      default () {
        return ''
      }
    },
    title: {
      type: String,
      required: false,
      default () {
        return null
      }
    },
    identifier: {
      type: Number,
      required: true,
      default () {
        return 0
      }
    },
    selectedValues: {
      type: Object || null,
      required: true,
      default() {
        return null
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    hasInfoIcon: {
      type: Boolean,
      default() {
        return false
      }
    },
    isSorted: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    dropdownValues: {
      get() {
        return this.selectedValues
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    items() {
      function compare(a, b) {
        if (!isNaN(a.value) && !isNaN(b.value)) {
          return +a.value - +b.value
        }
        else {
          if (a.value < b.value)
          {return -1}
          if (a.value > b.value)
          {return 1}
          return 0
        }
      }
      return this.isSorted ? this.filterValues.map(v => ({'label': v.label ?? v.value, 'value': v.value})).sort(compare) : this.filterValues.map(v => ({'label': v.label ?? v.value, 'value': v.value}))
    }
  },
  methods: {
    filterChangeHandler(event) {
      this.dropdownValues = event.value
    }
  },
  watch: {
    disabled: {
      immediate: true,
      handler(val) {
        if (val && this.dropdownValues && Object.keys(this.dropdownValues).length === 0) {
          this.dropdownValues = this.items[0]
        }
      }
    }
  }
}
</script>

<style lang="scss">
.filter-item-wrapper {
  position: relative;
  font-weight: $base-text-font-weight-light;

  .k-clear-value {
    display: none;
  }

  label .icon.infoIcon {
    position: absolute;
    top: -.5em;
    color: $color__primary;
    fill: $color__primary;
  }
}

</style>
